import { Pipe, PipeTransform } from '@angular/core';
import { Signer } from '@dpr/models/digital-signature';

@Pipe({ name: 'eSignStatusChange' })
export class ESignStatusChangePipe implements PipeTransform {
  transform(data: Signer, documentStatusChangedOn: Date): Date {
    return data?.statusChangedOn
      ? new Date(data?.statusChangedOn)
      : documentStatusChangedOn;
  }
}
